<template>
    <LoadingComponent :props="loading"/>
    <div class="row">
        <div class="col-12 lg:col-8">
            <div class="border rounded-lg p-4 mb-6">
                <div class="flex items-center rounded-2xl mb-4 w-fit text-gray-500 bg-gray-100">
                    <div class="relative cursor-pointer">
                        <input @change="changeOrderType(orderTypeEnum.DELIVERY)" id="checkout-delivery"
                            :checked="orderType === orderTypeEnum.DELIVERY"
                            :value="orderTypeEnum.DELIVERY"
                            class="cart-switch w-full h-full absolute top-0 left-0 opacity-0 cursor-pointer"
                            type="radio">
                        <label class="py-1.5 px-3.5 rounded-2xl text-sm font-semibold capitalize transition cursor-pointer"
                            for="checkout-delivery">{{ $t('label.shipping') }}</label>
                    </div>
                    <div class="relative cursor-pointer">
                        <input @change="changeOrderType(orderTypeEnum.PICK_UP)" id="checkout-delivery"
                            :checked="orderType === orderTypeEnum.PICK_UP"
                            :value="orderTypeEnum.PICK_UP"
                            class="cart-switch w-full h-full absolute top-0 left-0 opacity-0 cursor-pointer"
                            type="radio">
                        <label class="py-1.5 px-3.5 rounded-2xl text-sm font-semibold capitalize transition cursor-pointer"
                            for="checkout-delivery">{{ $t('label.pick_up') }}</label>
                    </div>
                </div>

                <div v-if="orderType === orderTypeEnum.PICK_UP" class="w-full">
                    <h4 class="font-bold capitalize pt-4 border-t">{{ $t('label.delivery_pick_up') }}</h4>

                    <div v-if="outlets.length > 0" v-for="outlet in outlets" class="pt-4">
                        <div class="flex p-2 border transition-all rounded-lg" :class=" outlet.id === modelOutlet.id ? 'border-primary/50 bg-primary/5' : 'border-[#F7F7F7] bg-[#F7F7F7]'">
                            <input type="radio" @change="outletAddress($event)" :id="outlet.name" :name="outlet.name" :value="outlet" :key="outlet" v-model="modelOutlet">
                            <label :for="outlet.name" class="px-2 text-sm capitalize cursor-pointer ">
                                <span class="font-semibold">{{ outlet.name }}</span> - {{ outlet.address }}, {{ outlet.city }}, {{ outlet.state }}, {{ outlet.zip_code }}
                            </label>
                        </div>
                    </div>
                </div>

                <!-- <div class="w-ful">
                    <h4 class="font-bold capitalize pt-4 border-t">{{ $t('label.select_salesman') }}</h4>

                    <div v-if="outlets.length > 0" v-for="outlet in outlets" class="pt-4">
                        <div class="flex p-2 border transition-all rounded-lg" :class=" outlet.id === modelOutlet.id ? 'border-primary/50 bg-primary/5' : 'border-[#F7F7F7] bg-[#F7F7F7]'">
                            <input type="radio" @change="outletAddress($event)" :id="outlet.name" :name="outlet.name" :value="outlet" :key="outlet" v-model="modelOutlet">
                            <label :for="outlet.name" class="px-2 text-sm capitalize cursor-pointer ">
                                <span class="font-semibold">{{ outlet.name }}</span> - Whastapp: [{{ outlet.country_code }}] {{ phoneFormat(outlet.phone) }}
                            </label>
                        </div>
                    </div>
                </div> -->

                <AddressComponent v-if="orderType === orderTypeEnum.DELIVERY" :slug="'shipping'"
                                :title="$t('label.shipping_address')" :show="true" :selectedAddress="getShippingAddress"
                                :method="shippingAddress"/>

                <div v-if="orderType === orderTypeEnum.DELIVERY && enableBillingAddress" class="flex items-start mt-6">
                    <input checked="checked" :value="shippingAndBillingCheck" @click="checkBillingCheckBox($event)"
                        type="checkbox"
                        id="shipping-and-billing-is-same" class="cs-custom-checkbox">
                    <label for="shipping-and-billing-is-same" class="font-semibold pl-2 leading-none cursor-pointer">{{
                            $t('message.save_shipping_address_as_a_billing_address')
                        }}</label>
                </div>

                <div v-if="orderType === orderTypeEnum.DELIVERY && enableBillingAddress" class="flex items-start mt-2">
                    <div v-if="shippingAndBillingCheck" class="text-sm font-medium">
                        <p>{{ $t('message.when_billing_is_required_1') }}</p>
                    </div>
                    <div v-else class="text-sm font-medium">
                        <p>{{ $t('message.when_billing_is_required_2') }}</p>
                    </div>
                </div>

                <AddressComponent v-if="orderType === orderTypeEnum.DELIVERY && enableBillingAddress" :slug="'billing'"
                                :title="$t('label.billing_address')" :show="billingStatus"
                                :selectedAddress="getBillingAddress" :method="billingAddress"/>

                <div v-if="orderType === orderTypeEnum.DELIVERY && !enableBillingAddress" class="mt-4 pt-4 border-t text-sm font-medium text-gray-500">
                    <p>{{ $t('message.request_invoice_via_email') }}</p>
                    <p v-if="isFreeShippingActive && setting.shipping_setup_free_shipping_default_text" class="mt-2 text-sm font-normal text-gray-500 whitespace-pre-line">
                        {{ setting.shipping_setup_free_shipping_default_text }}
                    </p>
                    <p v-if="!isFreeShippingActive && setting.shipping_setup_normal_shipping_default_text" class="mt-2 text-sm font-normal text-gray-500 whitespace-pre-line">
                        {{ setting.shipping_setup_normal_shipping_default_text }}
                    </p>
                </div>

            </div>

            <div class="max-lg:hidden flex items-center justify-start gap-3">
                <router-link :to="{ name: 'frontend.checkout.cartList' }"
                            :class="isQuoteCalculating ? 'pointer-events-none opacity-50' : ''"
                            class="field-button w-fit font-semibold tracking-wide normal-case text-secondary bg-[#E5E5EB]">
                    {{ $t('button.see_order_resume') }}
                </router-link>

                <button @click.prevent="selectAddress" 
                    :disabled="isQuoteCalculating || (orderType === orderTypeEnum.PICK_UP && !modelOutlet) || (orderType === orderTypeEnum.DELIVERY && !getShippingAddress.id)"
                    :class="[
                        ((orderType === orderTypeEnum.PICK_UP && !modelOutlet) || (orderType === orderTypeEnum.DELIVERY && !getShippingAddress.id)) ? 'disabled' : '',
                        isQuoteCalculating ? 'disabled:opacity-50 disabled:bg-gray-400' : ''
                    ]"
                    class="field-button w-fit font-semibold tracking-wide normal-case">
                    {{ $t('button.continue') }}
                </button>
            </div>
        </div>

        <div class="col-12 lg:col-4">
            <CouponComponent v-if="coupons.length > 0" />
            <SummeryComponent/>

            <div class="max-lg:flex hidden flex-col-reverse sm:flex-row items-center justify-between gap-5 mt-10">
                <router-link :to="{ name: 'frontend.checkout.cartList' }"
                             :class="isQuoteCalculating ? 'pointer-events-none opacity-50' : ''"
                             class="field-button font-semibold tracking-wide normal-case text-secondary bg-[#E5E5EB]">
                    {{ $t('button.see_order_resume') }}
                </router-link>

                <button @click.prevent="selectAddress" 
                    :disabled="isQuoteCalculating || (orderType === orderTypeEnum.PICK_UP && !modelOutlet) || (orderType === orderTypeEnum.DELIVERY && !getShippingAddress.id)"
                    :class="[
                        ((orderType === orderTypeEnum.PICK_UP && !modelOutlet) || (orderType === orderTypeEnum.DELIVERY && !getShippingAddress.id)) ? 'disabled' : '',
                        isQuoteCalculating ? 'disabled:opacity-50 disabled:bg-gray-400' : ''
                    ]"
                    class="field-button font-semibold tracking-wide normal-case">
                    {{ $t('button.continue') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import orderTypeEnum from "../../../../enums/modules/orderTypeEnum";
import AddressComponent from "./AddressComponent.vue";
import SummeryComponent from "../SummeryComponent.vue";
import CouponComponent from "../CouponComponent.vue";
import router from "../../../../router";
import alertService from "../../../../services/alertService";
import appService from "../../../../services/appService";
import LoadingComponent from "../../components/LoadingComponent.vue";
import statusEnum from "../../../../enums/modules/statusEnum";


export default {
    name: "CheckoutComponent",
    components: {CouponComponent, SummeryComponent, AddressComponent, LoadingComponent},
    data() {
        return {
            loading: {
                isActive: false
            },
            enums : {
                statusEnum: statusEnum
            },
            orderTypeEnum: orderTypeEnum,
            shippingAndBillingCheck: true,
            billingStatus: false,
            modelOutlet: 0
        }
    },
    computed: {
        coupons: function () {
            return this.$store.getters['frontendCoupon/lists'];
        },
        setting: function () {
            return this.$store.getters['frontendSetting/lists'];
        },
        orderType: function () {
            return this.$store.getters['frontendCart/orderType'];
        },
        getShippingAddress: function () {
            return this.$store.getters['frontendCart/shippingAddress'];
        },
        getBillingAddress: function () {
            return this.$store.getters['frontendCart/billingAddress'];
        },
        outlets: function () {
            return this.$store.getters['frontendOutlet/lists'];
        },
        isQuoteCalculating: function () {
            return this.$store.getters['frontendCart/quoteCalculating'];
        },
        enableBillingAddress: function () {
            if (this.setting && typeof this.setting.shipping_setup_enable_billing_address !== 'undefined') {
                return this.setting.shipping_setup_enable_billing_address === true || 
                       this.setting.shipping_setup_enable_billing_address === 'true' || 
                       this.setting.shipping_setup_enable_billing_address == 1;
            }
            return true;
        },
        isFreeShippingActive: function () {
            return this.$store.getters['frontendCart/isFreeShippingActive'];
        }
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch('frontendOrderArea/lists').then(res => {
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });

        this.loading.isActive = true;
        this.$store.dispatch('frontendOutlet/lists', {
            status : this.enums.statusEnum.ACTIVE
        }).then(res => {
            this.loading.isActive = false;
        }).catch((err) => {
            this.loading.isActive = false;
        });
    },
    methods: {
        phoneFormat(n) {
            return appService.phoneFormat(n);
        },
        changeOrderType: function (e) {
            this.$store.dispatch('frontendCart/updateOrderType', e)
        },
        shippingAddress: function (e) {
            this.$store.dispatch('frontendCart/shippingAddress', e).then().catch();
            if (this.shippingAndBillingCheck || !this.enableBillingAddress) {
                this.$store.dispatch('frontendCart/billingAddress', e).then().catch();
            }
        },
        billingAddress: function (e) {
            this.$store.dispatch('frontendCart/billingAddress', e).then().catch();
        },
        outletAddress: function(e) {
            setTimeout(() => {
                this.$store.dispatch('frontendCart/outletAddress', this.modelOutlet).then().catch();
            }, 100);
        },
        checkBillingCheckBox: function (e) {
            if (e.target.checked) {
                this.billingStatus           = false;
                this.shippingAndBillingCheck = true;
                this.$store.dispatch('frontendCart/billingAddress', this.getShippingAddress).then().catch();
            } else {
                this.billingStatus           = true;
                this.shippingAndBillingCheck = false;
            }
        },
        selectAddress: function () {
            if (this.orderType === orderTypeEnum.DELIVERY) {
                if (Object.keys(this.getShippingAddress).length === 0 || Object.keys(this.getBillingAddress).length === 0) {
                    alertService.error(this.$t("message.shipping_and_billing_address"));
                } else {
                    router.push({name: "frontend.checkout.payment"});
                }
            } else {
                router.push({name: "frontend.checkout.payment"});
            }
        }
    }
}
</script>

